// PROD-1042: identity of a deliver file-list entry, in the SAME order as the API's
// _deliver_item_keys (id, storagePath, path, fileKey, key, s3Key; non-empty strings only).
// A delete sends deliver._remove = { <listName>: [identity] }; the API never infers a patient removal.
const KEYS = ['id', 'storagePath', 'path', 'fileKey', 'key', 's3Key']

export function deliverEntryIdentity(entry) {
  if (!entry || typeof entry !== 'object') return []
  for (const k of KEYS) {
    if (typeof entry[k] === 'string' && entry[k].trim()) return [entry[k]]
  }
  return []
}

// PROD-1103/1104: the LOCAL file list after a write = the stored entries, plus the incoming entries
// whose identity is not there yet (an entry already there is replaced by the incoming copy, in place),
// minus the identities in removeIds. An incoming [] changes nothing. Mirrors the API's per-entry merge.
// Entries without any identity are appended (nothing to match them by).
export function mergeDeliverFileList(existing, incoming, removeIds) {
  const out = Array.isArray(existing) ? [...existing] : []
  const gone = new Set(Array.isArray(removeIds) ? removeIds.filter(x => typeof x === 'string' && x) : [])
  const at = (entry) => {
    const ids = deliverEntryIdentity(entry)
    return ids.length ? out.findIndex(e => deliverEntryIdentity(e).some(i => ids.includes(i))) : -1
  }
  for (const entry of Array.isArray(incoming) ? incoming : []) {
    const i = at(entry)
    if (i >= 0) out[i] = { ...out[i], ...entry }
    else out.push(entry)
  }
  return out.filter(e => !deliverEntryIdentity(e).some(i => gone.has(i)))
}
